angular.module('unica_archive_media.archive_media_services')

.factory('ArchiveMediaEditService', function ($http, getBaseApiURL) {

	var mediaEditService = {};

	mediaEditService.updateStatus = function (id, mediaData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/update-status/' + id,
			data: mediaData
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.changeDownloadable = function ( id )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/change-downloadable/' + id,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};



	return mediaEditService;
});